export type evidenceType =
  | 'CustomField'
  | 'Skill'
  | 'ActiveCertification'
  | 'EvaluationRating'
  | 'Credential';

export class EvidenceDefinition {
  constructor(
    public id: string,
    public attributeDefinitionId: string,
    public evidenceType: evidenceType,
    public credentialDefinitionId: string,
    public evidenceDefinitionName: string
  ) {}

  static parse(obj: any): EvidenceDefinition {
    return new EvidenceDefinition(
      obj.id,
      obj.attributeDefinitionId,
      obj.evidenceType,
      obj.credentialDefinitionId,
      obj.evidenceDefinitionName
    );
  }

  static EvidenceTypeOptions(): EvidenceOption[] {
    var options = Object.keys(EvidenceType).map((key) => {
      return { value: key, label: EvidenceType[key] };
    });
    return options;
  }
}

export type EvidenceOption = { value: string; label: string };
export enum EvidenceType {
  //NOTE: If you add a new value to this list you must update openAutomationOptions method in admin-requirement-side-bar.component.ts to cover the new value
  CustomField = 'Person Custom Field',
  Skill = 'Person Skill',
  ActiveCertification = 'Active Certification',
  EvaluationRating = 'Evaluation Rating',
  Credential = 'Credential',
}
